import { connect } from 'react-redux'
import { authActions } from 'store/user'
import { hasStudyPayments } from 'utils/misc'
import { getStudyVersionID, resolveRouteStudyId } from 'utils/studyConfigUtils'
import NavBar from './NavBar'

const navText = {
  studies: 'All Studies',
  audit: 'Audit Report',
}

const mapDispatchToProps = {
  onLogout: authActions.logout,
}

const mapStateToProps = (
  { user, userReducer, study, subroute, location, sending, studies, modal, navBar, view, studyLock, loading },
  ownProps,
) => {
  const { studyVersionID: studyVersionIDFromParams, studyID: studyIDFromParams } = ownProps?.params || {}
  const studyID = resolveRouteStudyId({
    location,
    paramsStudyID: studyIDFromParams,
    currentStudyId: study.currentStudy?.id,
  })
  const studyVersionID = getStudyVersionID(location) || studyVersionIDFromParams
  const selectedUser = userReducer ? userReducer.user.nickname : undefined
  const dropdownText =
    studies.length === 0 && navText[subroute] === 'studies'
      ? 'Create Study'
      : navText[subroute] || selectedUser || study.currentStudy.platform_name
  const disabled = sending.sendingState || sending.sentState
  return {
    studyLock,
    disabled,
    view,
    selectedUser,
    user,
    location,
    studies,
    modal,
    subroute,
    dropdownText,
    study: study.currentStudy,
    showNavLinks: subroute !== 'studies',
    navProps: navBar,
    hasPayments: hasStudyPayments(study.currentStudy),
    loadingStudy: loading.studyConfig,
    studyID,
    studyVersionID,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)
